module.exports = __webpack_public_path__ + "img/esben.97fe4ac3.png";